import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW";

export default function FechGetClubSettings(club) {

  var url = "/reservation/get_club_settings/" + club; 

  return FetchGetDataWithAuthNEW(url);
}

